import store from '@/store'
import webLog from './webLog'

/**
 * 执行animate动画和自定义动画，活动结束删除对应类名
 * @param {string} element css选择器字符串
 * @param {string} animation 动画名称
 */
export const animateCSS = (element, animation, prefix = 'animate__') =>
  // We create a Promise and return it
  new Promise((resolve, reject) => {
    const animationName = `${prefix}${animation}`
    const node = element instanceof HTMLElement ? element : document.querySelector(element)

    node.classList.add(`${prefix}animated`, animationName)

    // When the animation ends, we clean the classes and resolve the Promise
    function handleAnimationEnd(event) {
      event.stopPropagation()
      node.classList.remove(`${prefix}animated`, animationName)
      resolve('Animation ended')
    }

    node.addEventListener('animationend', handleAnimationEnd, { once: true })
  })

export const isMiniProgram = () => {
  return new Promise((resolve) => {
    if (navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1) {
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve(true)
        } else {
          resolve(false)
        }
      })
    } else {
      resolve(false)
    }
  })
}

export const isFangCheBaoApp = () => {
  const query = {}
  const queryStr = location.href.split('?')[1] || ''
  queryStr.split('&').forEach((item) => {
    const [key, value] = item.split('=')
    query[key] = value
  })
  if (query.source === 'fangchebao') {
    localStorage.setItem('fangchebao_flag', 1)
  }
  return query.source === 'fangchebao' || localStorage.getItem('fangchebao_flag')
}

export const isIOS = () => {
  return navigator.userAgent.toLowerCase().indexOf('iphone') > -1
}

export const isAndroid = () => {
  return navigator.userAgent.toLowerCase().indexOf('android') > -1 || navigator.userAgent.indexOf('adr') > -1
}

/**
 * 阿里云日志上报
 * @param {object} params
 */
export const sendLog = (params) => {
  webLog.sendImmediate({
    sysName: 'mall',
    url: location.href,
    userAgent: navigator.userAgent,
    token: store.state?.userInfo?.acpToken,
    ...params,
  })
}

/**
 * 上报事件，添加浏览时长参数
 */
export const collectEventAddDuration = async (eventName, params) => {
  // App 1.0.8以后的版本新增了返回钩子函数
  if (hcApp.isHCApp && hcApp.isGreaterThan('1.0.8')) {
    const viewStartTime = new Date().getTime()
    await hcApp.postMessage({
      methodName: 'registerBackHook',
    })
    const viewEndTime = new Date().getTime()
    params.event_duration = Number(((viewEndTime - viewStartTime) / 1000).toFixed())
    console.log('浏览时长：', params)
    window.collectEvent(eventName, params)
    setTimeout(() => {
      hcApp.postMessage({ methodName: 'goBack' })
    }, 200)
  } else {
    console.log('不支持返回钩子函数，立即发送统计事件')
    window.collectEvent(eventName, params)
  }
}
